import { takeEvery, put, call } from "redux-saga/effects";

import {
  getGovernoratesAPI,
  addGovernorateAPI,
  getGovernorateAPI,
  updateGovernorateAPI,
  deleteGovernorateAPI,
  getGovernoratesSelectListAPI,
} from "../../../helpers/backend.helper";
import {
  GET_GOVERNORATES,
  ADD_GOVERNORATE,
  GET_GOVERNORATE,
  UPDATE_GOVERNORATE,
  DELETE_GOVERNORATE,
  GET_GOVERNORATES_SELECT_LIST,
} from "./actionTypes";
import {
  addGovernorateError,
  addGovernorateSuccess,
  deleteGovernorateError,
  deleteGovernorateSuccess,
  getGovernorateError,
  getGovernoratesError,
  getGovernoratesSelectListError,
  getGovernoratesSelectListSuccess,
  getGovernoratesSuccess,
  getGovernorateSuccess,
  updateGovernorateError,
  updateGovernorateSuccess,
} from "./actions";

function* getGovernorates({ payload: { request } }) {
  try {
    const response = yield call(getGovernoratesAPI, request);
    if (response) {
      yield put(getGovernoratesSuccess(response?.data));
    }
  } catch (error) {
    yield put(getGovernoratesError(error));
  }
}

function* addGovernorate({ payload: { request } }) {
  try {
    const response = yield call(addGovernorateAPI, request);
    if (response) {
      yield put(addGovernorateSuccess());
    }
  } catch (error) {
    yield put(addGovernorateError(error));
  }
}

function* getGovernorate({ payload: { id } }) {
  try {
    const response = yield call(getGovernorateAPI, id);
    if (response) {
      yield put(getGovernorateSuccess(response?.data));
    }
  } catch (error) {
    yield put(getGovernorateError(error));
  }
}

function* updateGovernorate({ payload: { request } }) {
  try {
    const response = yield call(updateGovernorateAPI, request);
    if (response) {
      yield put(updateGovernorateSuccess());
    }
  } catch (error) {
    yield put(updateGovernorateError(error));
  }
}

function* deleteGovernorate({ payload: { id } }) {
  try {
    const response = yield call(deleteGovernorateAPI, id);
    if (response) {
      yield put(deleteGovernorateSuccess());
    }
  } catch (error) {
    yield put(deleteGovernorateError(error));
  }
}

function* getGovernoratesSelectList() {
  try {
    const response = yield call(getGovernoratesSelectListAPI);
    if (response) {
      yield put(getGovernoratesSelectListSuccess(response?.data));
    }
  } catch (error) {
    yield put(getGovernoratesSelectListError(error));
  }
}

function* governorateSage() {
  yield takeEvery(GET_GOVERNORATES, getGovernorates);
  yield takeEvery(ADD_GOVERNORATE, addGovernorate);
  yield takeEvery(GET_GOVERNORATE, getGovernorate);
  yield takeEvery(UPDATE_GOVERNORATE, updateGovernorate);
  yield takeEvery(DELETE_GOVERNORATE, deleteGovernorate);
  yield takeEvery(GET_GOVERNORATES_SELECT_LIST, getGovernoratesSelectList);
}

export default governorateSage;
